import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <Link to="/" onClick={closeMenu} style={{ display: 'flex', alignItems: 'center', gap: '12px', textDecoration: 'none' }}>
            <img src="/files/balci-mobilya-logo.png" alt="Balcı Mobilya Logo" style={{ height: '50px', width: 'auto', display: 'block' }} />
            <h1>Balcı Mobilya</h1>
          </Link>
        </div>
        
        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-list">
            <li className="nav-item">
              <Link 
                to="/" 
                className={location.pathname === '/' ? 'active' : ''}
                onClick={closeMenu}
              >
                Ana Sayfa
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/mobilya" 
                className={location.pathname === '/mobilya' ? 'active' : ''}
                onClick={closeMenu}
              >
                Mobilya
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/beyaz-esya" 
                className={location.pathname === '/beyaz-esya' ? 'active' : ''}
                onClick={closeMenu}
              >
                Beyaz Eşya
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/yatak-baza-baslik" 
                className={location.pathname === '/yatak-baza-baslik' ? 'active' : ''}
                onClick={closeMenu}
              >
                Yatak
              </Link>
            </li>
                        <li className="nav-item">
              <Link 
                to="/kurumsal" 
                className={location.pathname === '/kurumsal' ? 'active' : ''}
                onClick={closeMenu}
              >
                Kurumsal
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/iletisim" 
                className={location.pathname === '/iletisim' ? 'active' : ''}
                onClick={closeMenu}
              >
                İletişim
              </Link>
            </li>
          </ul>
        </nav>
        
        <div className="hamburger" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>
  );
};

export default Header; 